import { handleActions } from 'redux-actions'
import Immutable from 'immutable'

import * as actions from '../actions/user';

const initialState = Immutable.fromJS({
  data: [],
  delete: {},
  loading: false,
  loaded: false
})

export default handleActions({
  [actions.registarSucceeded](state, { payload }) {
    return state.set('loading', false).set('loaded', true)
      .set('data', Immutable.fromJS(payload.data));
  },
  [actions.registarFailed](state, action) {
    return state.set('loading', false)
      .merge(Immutable.fromJS({ error: action.payload }))
  },
  [actions.getUserNameSucceeded](state, { payload }) {
    return state.set('loading', false).set('loaded', true)
      .set('data', Immutable.fromJS(payload.data));
  },
  [actions.getUserNameFailed](state, action) {
    return state.set('loading', false)
      .merge(Immutable.fromJS({ error: action.payload }))
  },
  [actions.getUserinfoSucceeded](state, { payload }) {
    return state.set('loading', false).set('loaded', true)
      .set('data', Immutable.fromJS(payload.data));
  },
  [actions.getUserinfoFailed](state, action) {
    return state.set('loading', false)
      .merge(Immutable.fromJS({ error: action.payload }))
  },
  [actions.getUserFreezeFailed](state, action) {
    return state.set('loading', false)
      .merge(Immutable.fromJS({ error: action.payload }))
  },
  [actions.getUserDeleteSucceeded](state, { payload }) {
    return state.set('loading', false).set('loaded', true)
      .set('data', Immutable.fromJS(payload.data));
  },
  [actions.getUserDeleteFailed](state, action) {
    return state.set('loading', false)
      .merge(Immutable.fromJS({ error: action.payload }))
  }
}, initialState)



// WEBPACK FOOTER //
// ./reducers/user.js